import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone, ArrowUpRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Compliance", href: "#compliance" },
  { label: "What We Deliver", href: "#deliver" },
  { label: "Facilities", href: "#facilities" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  return (
    <header data-testid="header-nav-bar" className="fixed top-0 inset-x-0 z-50">
      <div className="glass border-b border-slate-200/60">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 h-[72px] flex items-center justify-between gap-4">
          <a href="#top" data-testid="nav-brand-link" className="flex items-center gap-3 shrink-0">
            <img src="/assets/hlm-logo-mark.png" alt="HLM Courier" data-testid="nav-logo" className="h-11 w-auto" />
            <span className="hidden sm:flex items-center gap-1.5 text-[10px] font-mono font-semibold tracking-[0.18em] text-slate-500 uppercase whitespace-nowrap">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse-dot" />
              24/7 Dispatch Active
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-6">
            {LINKS.map((l) => (
              <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                 className="text-sm font-semibold whitespace-nowrap text-slate-600 hover:text-[#0047FF] transition-colors duration-200">
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3 shrink-0">
            <a href="tel:5718509387" data-testid="nav-phone-cta"
               className="flex items-center gap-2 whitespace-nowrap text-sm font-bold text-slate-800 hover:text-[#0047FF] transition-colors duration-200">
              <Phone className="h-4 w-4" /> (571) 850-9387
            </a>
            <Link to="/portal" data-testid="nav-login-btn"
                  className="text-sm font-bold px-4 py-2.5 rounded-full border border-slate-300 text-slate-700 hover:border-[#0047FF] hover:text-[#0047FF] transition-colors duration-200">
              {user ? "My Portal" : "Client Login"}
            </Link>
            <a href="#quote" data-testid="nav-quote-cta"
               className="group flex items-center gap-1.5 text-sm font-bold px-5 py-2.5 rounded-full bg-[#0047FF] text-white hover:bg-[#0037CC] transition-colors duration-200 shadow-lg shadow-blue-600/25">
              Get a Quote
              <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>

          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)}
                  className="lg:hidden h-10 w-10 flex items-center justify-center rounded-xl border border-slate-200 text-slate-700">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>

        {open && (
          <div data-testid="nav-mobile-menu" className="lg:hidden border-t border-slate-200/60 px-6 py-5 space-y-1 bg-white/95">
            {LINKS.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)}
                 className="block py-2.5 text-sm font-semibold text-slate-700">
                {l.label}
              </a>
            ))}
            <div className="flex flex-col gap-2.5 pt-4">
              <a href="tel:5718509387" data-testid="nav-mobile-phone" className="flex items-center gap-2 text-sm font-bold text-slate-800">
                <Phone className="h-4 w-4" /> (571) 850-9387
              </a>
              <Link to="/portal" data-testid="nav-mobile-login" onClick={() => setOpen(false)}
                    className="text-center text-sm font-bold px-4 py-3 rounded-full border border-slate-300 text-slate-700">
                {user ? "My Portal" : "Client Login"}
              </Link>
              <a href="#quote" data-testid="nav-mobile-quote" onClick={() => setOpen(false)}
                 className="text-center text-sm font-bold px-4 py-3 rounded-full bg-[#0047FF] text-white">
                Get a Quote
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
